import type { IQuestion } from '@repo/types/questions/Question.interface';
import type {
  AnswerUserQuestionTranslate,
  ExportAnswerTranslate,
  FeedbackAnswerQuestionTranslate,
  OptionQuestionTranslate,
  QuestionTranslateContent,
  QuestionTranslateData,
  QuestionTranslateSerialized,
} from '@repo/types/questions/QuestionTranslate';
import type { CorrectType } from '@repo/types/quiz';

import { QuestionType } from '@repo/types/enums/questionType';

export class QuestionTranslate implements IQuestion {
  readonly type: QuestionType;
  readonly content: string;
  private options: OptionQuestionTranslate[];
  private readonly points: number = 0;
  private selectedAnswer: AnswerUserQuestionTranslate | null = null;
  private marked: FeedbackAnswerQuestionTranslate | null = null;
  constructor(data: QuestionTranslateData, selectedAnswer: AnswerUserQuestionTranslate | null, marked: FeedbackAnswerQuestionTranslate | null) {
    this.type = QuestionType.TRANSLATE;

    this.content = data.content;
    this.options = data.options;
    this.points = data.points;
    this.selectedAnswer = selectedAnswer;
    this.marked = marked;
  }

  getContent(): QuestionTranslateContent {
    return {
      content: this.content,
      options: this.options,
    };
  }

  getMaxPoints(): number {
    return this.points;
  }

  getPoints(): number {
    if (this.marked == null) return 0;

    return this.marked.points ?? 0;
  }

  setAnswer(ids: number[]): void {
    this.selectedAnswer = ids;
  }

  getAnswer(): number[] | null {
    return this.selectedAnswer;
  }

  isAnswered(): boolean {
    return this.selectedAnswer ? this.selectedAnswer.length > 0 : false;
  }

  resetAnswer(): void {
    this.selectedAnswer = null;
  }

  setMarked(marked: FeedbackAnswerQuestionTranslate): void {
    this.marked = marked;
  }

  getMarked(): FeedbackAnswerQuestionTranslate | null {
    return this.marked;
  }

  isMarked(): boolean {
    return !(this.marked == null);
  }

  correctState(): CorrectType {
    if (!this.isAnswered()) return null;

    const isCorrect: boolean | undefined = this.marked?.correct;
    if (isCorrect !== undefined) {
      return isCorrect;
    }

    const points: number = this.getPoints();
    const maxPoints: number = this.getMaxPoints();

    if (points == 0) return false;
    return points == maxPoints ? true : 'partially';
  }

  toJSON(): QuestionTranslateSerialized {
    return {
      marked: this.marked,
      selectedAnswer: this.selectedAnswer,
    };
  }

  importAnswer(answer: ExportAnswerTranslate): void {
    if (answer.ids) {
      this.selectedAnswer = answer.ids;
    } else {
      this.selectedAnswer = null;
    }
  }

  exportAnswer(): ExportAnswerTranslate {
    return {
      ids: this.selectedAnswer,
    };
  }
}
